/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Document_Analysis_CompleteInputs */

const en_document_analysis_complete = /** @type {(inputs: Document_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document analysis complete!`)
};

const es_document_analysis_complete = /** @type {(inputs: Document_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Análisis de documento completo!`)
};

const fr_document_analysis_complete = /** @type {(inputs: Document_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyse du document terminée !`)
};

const de_document_analysis_complete = /** @type {(inputs: Document_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumentenanalyse abgeschlossen!`)
};

const ja_document_analysis_complete = /** @type {(inputs: Document_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドキュメント分析が完了しました！`)
};

const zh_document_analysis_complete = /** @type {(inputs: Document_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文档分析完成！`)
};

const ar_document_analysis_complete = /** @type {(inputs: Document_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اكتمل تحليل المستند!`)
};

const id_document_analysis_complete = /** @type {(inputs: Document_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisis dokumen selesai!`)
};

const it_document_analysis_complete = /** @type {(inputs: Document_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisi del documento completata!`)
};

const ru_document_analysis_complete = /** @type {(inputs: Document_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Анализ документа завершен!`)
};

const pt_document_analysis_complete = /** @type {(inputs: Document_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análise de documento concluída!`)
};

const ko_document_analysis_complete = /** @type {(inputs: Document_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문서 분석 완료!`)
};

/**
* | output |
* | --- |
* | "Document analysis complete!" |
*
* @param {Document_Analysis_CompleteInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const document_analysis_complete = /** @type {((inputs?: Document_Analysis_CompleteInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Document_Analysis_CompleteInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_document_analysis_complete(inputs)
	if (locale === "es") return es_document_analysis_complete(inputs)
	if (locale === "fr") return fr_document_analysis_complete(inputs)
	if (locale === "de") return de_document_analysis_complete(inputs)
	if (locale === "ja") return ja_document_analysis_complete(inputs)
	if (locale === "zh") return zh_document_analysis_complete(inputs)
	if (locale === "ar") return ar_document_analysis_complete(inputs)
	if (locale === "id") return id_document_analysis_complete(inputs)
	if (locale === "it") return it_document_analysis_complete(inputs)
	if (locale === "ru") return ru_document_analysis_complete(inputs)
	if (locale === "pt") return pt_document_analysis_complete(inputs)
	return ko_document_analysis_complete(inputs)
});